import { cert_icon, rvp_icon } from '../shared/iconSvgs';
export const serviceLinks = [
    {
        icon: rvp_icon,
        displayName: 'Athlete Safety/RVP',
        description: 'Registered Volunteer Information',
        route: '/AthleteSafetyRVP',
        actionText: 'Manage Athlete Safety Portal',
    },
    {
        icon:  cert_icon,
        displayName: 'SafeSport Certificates',
        description: 'Print completed SafeSport Training certificates',
        route: '/Certificates',
        actionText: 'Go to Print SafeSport Certificates',
    }
];
export const helpLinks = [
    {
        //icon:,
        displayName: 'Athlete Safety Information',
        //description: 'Description Here',
        homeUrl: process.env.REACT_APP_ATHLETE_SAFETY_INFO_URL
    },
    {
        //icon:,
        displayName: 'Athlete Safety/RVP Handbook',
        //description: 'Description Here',
        homeUrl: process.env.REACT_APP_ATHLETE_SAFETY_HANDBOOK_URL
    },
    {
        //icon:,
        displayName: 'SafeSport Training Instructions',
        //description: 'Description Here',
        route: '/AthleteSafetyRVP/TrainingStepByStep'
    },
    {
        //icon:,
        displayName: 'FAQ',
        //description: 'Description Here',
        homeUrl: process.env.REACT_APP_ASP_FAQ_URL
    },
    {
        //icon:,
        displayName: 'Registered Volunteer Lookup',
        //description: 'Description Here',
        homeUrl: process.env.REACT_APP_REGISTERED_VOLUNTEER_LOOKUP_URL,
    }
];